<div class="loader-refresh">
  <i class="fal fa-sync fa-spin text-primary"></i>
  Daten werden synchronisiert.
  @if (showInitialText()) {
    <span>Beim ersten Laden kann die Synchronisation einige Minuten in Anspruch nehmen.</span>
  }
</div>
